export const hurrianSuffixPositions: { [key: string]: string[] } = {
  'noun': ['rlt', 'poss', 'num', 'them', 'cas', 'rlt2', 'poss2', 'num2', 'them2', 'cas2'],
  'modal': ['valence', 'l', 'mood'],
  'voice': ['res', 'voice', 'person'],
  'aspect': ['res', 'aspect', 'person'],
  // 'enclitic': ['pron', 'part']
};

export const hurrianEncliticSuffixPositions = ['pron', 'part'];